import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Cell } from "fixed-data-table-2"

// components
import { Icon as DSIcon } from "quorumdesign"

// helper functions
import { cleanUpHtml } from "imports/desktopHelperFunctions"

// selectors
import { dashboardDatumCellConnection } from "app/static/frontend/sheets/components/cells/cell-selectors/datum-cell-selectors"

export const DashboardDatumCell = props => (
    <Cell
        {...props}
    >
        { cleanUpHtml(props.datum.get(DjangIO.app.models.QuorumDataType.dashboard.display_key)) }
        {/* add space between dashboard name and icon */}
        {" "}
        {props.isHomepageDashboard && (
            <DSIcon
                icon="home"
            />
        )}
    </Cell>
)
DashboardDatumCell.propTypes = {
    datum: PropTypes.object,
    isHomepageDashboard: PropTypes.bool,
}

export default connect(dashboardDatumCellConnection)(DashboardDatumCell)
